import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Observable, of, Subscription } from 'rxjs';
import { NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PaginatorState} from '../../../_Core/shared/crud-table';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from '../../i18n/translation.service';
import { AuthModel } from '../../auth/_models/auth.model';
import { AuthService } from '../../auth';
import { catchError } from 'rxjs/operators';
import { HotToastService } from '@ngneat/hot-toast';
import { AppointmentService } from '../_services/appointments.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
})
export class SearchComponent implements OnInit, OnDestroy {
  paginator: PaginatorState;
  isLoading$: Observable<boolean>;
  searchGroup: UntypedFormGroup;
  private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  panelOpenState = true;
  language: any;
  user$: Observable<AuthModel>;
  roles: string[];
  PatientId;
  model: NgbDateStruct;
  IqamaID;
  constructor(private fb: UntypedFormBuilder,
    private toast: HotToastService, 
    private route: ActivatedRoute,private router: Router,
    private modalService: NgbModal, public AppointmentService: AppointmentService,
    private translationService: TranslationService, private auth: AuthService) {
    this.user$ = this.auth.currentUserSubject.asObservable();
  }
  ngOnInit(): void {
    // const sb =  this.user$.subscribe(res => {
    //   if (res.userId) {
    //     this.roles = res.roles;
    //     if (res.isGuest && res.iqamaId != null && res.iqamaId !='')
    //     {
    //       this.PatientId = null;
    //       this.IqamaID = res.iqamaId;
    //     }
    //     else
    //     {
    //       this.IqamaID = null;
    //       this.PatientId = res.userId;

    //     }
    //   }
    // });
    // this.subscriptions.push(sb);

    this.language = this.translationService.getSelectedLanguage();
    this.searchForm();
    this.isLoading$ = this.AppointmentService.isLoading$;
    this.paginator = this.AppointmentService.paginator;
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
    this.AppointmentService.Clearitems$();
  }
  onSubmit() {
    this.search();
    this.isLoading$ = this.AppointmentService.isLoading$;
  }
 
  // search
  searchForm() {
    this.searchGroup = this.fb.group({
      // PatientId:[this.PatientId],
      // IqamaId : [this.IqamaID],
      Fromdate: [''],
      Enddate: [''],
    });
  }
  Clear() {
    this.searchGroup.patchValue({Fromdate:''})
    this.searchGroup.patchValue({Enddate:''})
  }
  search() {

    let Fromdate = new Date(this.searchGroup.controls.Fromdate.value.year,this.searchGroup.controls.Fromdate.value.month-1,this.searchGroup.controls.Fromdate.value.day)
    let Enddate = new Date(this.searchGroup.controls.Enddate.value.year,this.searchGroup.controls.Enddate.value.month-1,this.searchGroup.controls.Enddate.value.day)

    let filtersDTO = {
      Fromdate: this.FormateDate(Fromdate),
      Enddate: this.FormateDate(Enddate),
      // PatientId: this.PatientId,
      // IqamaId: this.IqamaID
    }
    this.AppointmentService.patchState({ filter: filtersDTO });
  }
  // GoToView(Visit)
  // {
  //   sessionStorage.setItem('Visit',JSON.stringify(Visit));
  //   this.router.navigate(['/portal/appointments/view/' ], { relativeTo: this.route });
  // }
  OpenConfirmationModel(AppoinmentId,AppointmentFlag)
  {
    
    const modalRef = this.modalService.open(ConfirmationModalComponent);
    modalRef.componentInstance.AppoinmentId = AppoinmentId;
    modalRef.componentInstance.AppointmentFlag = AppointmentFlag;
  }
  paginate(paginator: PaginatorState) {
    this.AppointmentService.patchState({ paginator });
  }
  FormateDate(RequestDate: Date) {
    RequestDate = new Date(RequestDate);
    let hoursDiff = RequestDate.getHours() - RequestDate.getTimezoneOffset() / 60;
    let minutesDiff = (RequestDate.getHours() - RequestDate.getTimezoneOffset()) % 60;
    RequestDate.setHours(hoursDiff);
    RequestDate.setMinutes(minutesDiff);
    return RequestDate;
  }
}
